export const OrdersResource = {
  name: "Orders",
  path: "/sales/orders",
  access: ["read-salesorders"],
};
